import { render, staticRenderFns } from "./LeadsCard.vue?vue&type=template&id=3166db90&scoped=true"
import script from "./LeadsCard.vue?vue&type=script&lang=js"
export * from "./LeadsCard.vue?vue&type=script&lang=js"
import style0 from "./LeadsCard.vue?vue&type=style&index=0&id=3166db90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166db90",
  null
  
)

export default component.exports